import { backOff } from "exponential-backoff"

import ENV from "../env"
import { NORMAL_OPERATION } from "../settings"

export class BackendError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "BackendError"
  }
}

// `T` is a generic type for the return type of the function.
// `Args` is a tuple type representing the argument types of the function `fn`.
export function retryable<T, Args extends any[]>(
  fn: (...args: Args) => Promise<T>, // Function to be retried
  timeoutConfig = NORMAL_OPERATION,
): (...args: Args) => Promise<T> {
  const { maxTries, initialDelay } = timeoutConfig

  // Return a new function that wraps the original function
  return async function (...args: Args): Promise<T> {
    return backOff(() => fn(...args), {
      delayFirstAttempt: initialDelay > 0,
      startingDelay: initialDelay,
      timeMultiple: 1.1, // Default is `2`
      numOfAttempts: maxTries, // Maximum number of retry attempts
      retry: (error, attemptNumber) => {
        console.warn("onRetryFailed", attemptNumber, error)
        if (error instanceof BackendError) {
          return false // Stop retrying if it's a BackendError
        }
        return true // Continue retrying if there's an error
      },
    })
  }
}

export const isBrowser = typeof window !== "undefined"
export const isStaging = isBrowser && window.location.toString().includes("staging")
export const isDevelopment = isBrowser && window.location.toString().includes("localhost")
export const showExperimentalFeatures =
  isStaging ||
  isDevelopment ||
  ENV.VITE_ENV === "staging" ||
  (isBrowser && window.location.toString().includes("experimental"))
